import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Collapse from '@mui/material/Collapse';
import {
  mobileEventContainer,
  mobileEventDot,
  mobileEventLine,
  mobileEventCard,
  timelineDialogStyles,
} from './actionLockTimelineStyles';
import { ActionLockEvent } from '../../../types/types';
import { useActionLockTimelineScroll } from '../../../hooks/useActionLockTimelineScroll';
import { format, parseISO } from 'date-fns';

interface ActionLockMobileTimelineProps {
  events: ActionLockEvent[];
  selectedId: number | null;
  onSelect: (id: number) => void;
}

const ActionLockMobileTimeline: React.FC<ActionLockMobileTimelineProps> = ({
  events,
  selectedId,
  onSelect,
}) => {
  const itemRefs = useActionLockTimelineScroll<HTMLDivElement>(selectedId);

  return (
    <Box sx={timelineDialogStyles.mobileCard}>
      {events.map((event, index) => {
        const isSelected = selectedId === event.id;
        const isLast = index === events.length - 1;

        return (
          <Box key={event.id} id={`event-${event.id}`} sx={mobileEventContainer(isLast)}>
            <Box sx={mobileEventDot(isSelected)} />
            {!isLast && <Box sx={mobileEventLine()} />}
            <Paper
              ref={(el) => el && (itemRefs.current[event.id] = el)}
              role="button"
              tabIndex={0}
              aria-expanded={isSelected}
              onClick={() => onSelect(event.id)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') onSelect(event.id);
              }}
              sx={mobileEventCard(isSelected)}
            >
              <Typography variant="subtitle1" sx={timelineDialogStyles.cardTitle}>
                Port {event.action} ({event.interfaces})
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {format(parseISO(`${event.locked_at}Z`), 'yyyy-MM-dd HH:mm')}
              </Typography>
              <Collapse in={isSelected}>
                <Typography variant="body2" sx={timelineDialogStyles.cardText}>
                  user: {event.user_email}
                </Typography>
              </Collapse>
            </Paper>
          </Box>
        );
      })}
    </Box>
  );
};

export default ActionLockMobileTimeline;
